import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { WidgetStatePlaceholderEnum } from '@shared/enums/widget-state-placeholder.enum';

import { CustomEventService } from '@shared/services/custom-event.service';
import { WidgetService } from '@shared/services/widget.service';

import { EChartOption } from 'echarts';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-custom-addon-table-widget',
  templateUrl: './custom-addon-table-widget.component.html'
})
export class CustomAddonTableWidgetComponent implements OnInit {

  @Input() dateFilterable: boolean;
  widgetId: string;
  widgetName: string;
  widgetType: string;
  widgetFooter: Widget.FooterModel;
  headerAddon: string;
  headerComponents: [] = [];
  selectedDate: string;
  note: string;
  url: string;
  from: number;
  showDownloadIcon: boolean;

  loading: boolean;
  initialLoading: boolean;
  widgetStatePlaceholderEnum = WidgetStatePlaceholderEnum;
  showWidgetStatePlaceholder: WidgetStatePlaceholderEnum;

  widgetData: any;
  toolTipHTML: string;

  chartOption: EChartOption;
  echartsColors: string[];

  @ViewChild('toolTipTitle', { static: true }) toolTipTitle: TemplateRef<any>;
  tooltipContent: string;

  @Input()
  set period(period: string) {
    if (period === 'FROM') {
      this.selectedDate = this.from.toString(10);
    } else if (period === 'TODAY') {
      this.selectedDate = `${period}`;
    } else if (period) {
      this.selectedDate = `FROM_LAST_${period}`;
    }
  };
  constructor(private widgetService: WidgetService,
              private customEventService: CustomEventService) { }

  ngOnInit(): void {
    this.toolTipHTML = this.headerComponents.join('<br>');
    this.loadWidgetData(true);

    // Subscribe to the dashboard announcements to update
    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.UPDATE_WIDGET_DATA) {
        this.loadWidgetData();
      }

      if (action === ActionTypesEnum.UPDATE_WIDGET_DATE) {
        const { id, date } = data;

        if (this.widgetId === id ) {
          this.selectedDate = date;
          this.loadWidgetData();
        }
      }
    });
  }

  loadWidgetData(initial?: boolean): void {
    this.loading = true;

    if (initial) {
      this.initialLoading = true;
    }

    this.widgetService.get(this.widgetId, this.selectedDate)
      .pipe(untilDestroyed(this), take(1))
      .subscribe(response => {
        this.initialLoading = false;
        if (!response.data) {
          this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
          return;
        }
        this.showWidgetStatePlaceholder = undefined;

        if (response.footer) {
          this.widgetFooter = response.footer;
        }

        this.widgetData = response.data;
        this.loading = false;
      }, error => {
        console.log('error while fetching widget data', error);
        this.loading = false;
        this.initialLoading = false;
        this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
      });
  }
}
